import React from 'react';
import useGetSouscriptionInformationsQuery from './hooks/useGetSouscriptionInformationsQuery.js';
import SouscriptionInformationsForm from './SouscriptionInformationsForm.jsx';
import { Loading } from '@fasstech/middle-design-system';
import { compose } from 'ramda';
import withGlobalData from '@@viewCommonHoc/withGlobalData.jsx';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures.jsx';

const SouscriptionInformations = ({
  middleFeatures,
  getMiddleText,
  getMiddleBoolean,
  phoneIndicatives,
  internationalPhoneIndicatives
}) => {
  const { getSouscriptionInformations, loading: isLoadingGetSouscriptionInformations } =
    useGetSouscriptionInformationsQuery();

  if (isLoadingGetSouscriptionInformations) {
    return <Loading />;
  }

  return (
    <SouscriptionInformationsForm
      getMiddleText={getMiddleText}
      getMiddleBoolean={getMiddleBoolean}
      middleFeatures={middleFeatures}
      data={getSouscriptionInformations}
      phoneIndicatives={phoneIndicatives}
      internationalPhoneIndicatives={internationalPhoneIndicatives}
    />
  );
};

export default compose(withGlobalData, withMiddleFeatures)(SouscriptionInformations);
